import { useEffect } from 'react'
import { create } from 'zustand'
import { ethers } from 'ethers'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'

/* eslint-disable class-methods-use-this, react-hooks/rules-of-hooks */

/**
 * dummy class to extract Web3ReactContextInterface
 */
class ExtractWeb3ReactContextInterface<T> {
  useWeb3React() {
    return useWeb3React<T>()
  }
}
type Web3ReactContextInterface<T> = ReturnType<ExtractWeb3ReactContextInterface<T>['useWeb3React']>
type SignerProvider = ethers.Signer

interface Web3 {
  web3: Web3ReactContextInterface<Web3Provider>
  signer: ethers.Signer | null
  account: string | null
}

const web3AccountStore = create<Web3>(() => ({
  web3: null,
  signer: null,
  account: null,
}))

export const useConnectWeb3Account = () => {
  const web3 = useWeb3React<Web3Provider>()

  useEffect(() => {
    const account = web3.account || null
    web3AccountStore.setState({
      web3,
      signer: account ? web3.library.getSigner() : null,
      account,
    })
    if (web3?.account) {
      console.debug('web3 connection updated, account: ', web3.account)
    } else {
      console.debug('web3 connection updated, no account')
    }
  }, [web3])
}

export const getSigner = (): SignerProvider => {
  return web3AccountStore.getState().signer
}

export const getAccount = (): string | null => {
  return web3AccountStore.getState().account
}

export const onAccountInitOrChange = (callbackFn: (account: string) => any) => {
  return web3AccountStore.subscribe((state, prevState) => {
    if (state.account !== prevState.account) {
      callbackFn(state.account)
    }
  })
}
